import React from 'react';
import { TableCell, TableRow} from '@mui/material';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import {OutlinedInput, MenuItem, Chip, Stack} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import styled from 'styled-components';

const ButtonWrapper = styled.div`
  display: flex;
`

const VendorMasterEditable = ({k,row, editFormData, handleCancelClick,assetmaster, brandmaster,
  page, rowsPerPage, onChangeEditVendor,  SubmitButton}) =>{
   return( 
   <>
     <TableRow key={k} name={row.Category}>
       <TableCell component="th" scope="row">
         {(page)*(rowsPerPage)+k+1}
       </TableCell>

       <TableCell  align="left">
        <TextField
            id="outlined-basic"
            size='small'
            name='vendorname'
            onChange={(event, newValue) => onChangeEditVendor(event, newValue)}
            label="Enter New Model Number"
            value={editFormData?.vendorname || ""}
            variant="outlined"
            sx={{backgroundColor:"white", width:"250px", height:"40px"}}
        />
        </TableCell>

         
       <TableCell  align="left">
        <TextField
              id="outlined-basic"
              size='small'
              name='contactno'
              onChange={(event, newValue) => onChangeEditVendor(event, newValue)}
              label="Enter New Model Number"
              value={editFormData?.contactno || ""}
              variant="outlined"
              sx={{backgroundColor:"white", width:"250px", height:"40px"}}
          />
       </TableCell>

       <TableCell  align="left">
        <TextField
              id="outlined-basic"
              size='small'
              name='vendoremail'
              onChange={(event, newValue) => onChangeEditVendor(event, newValue)}
              label="Enter New Model Number"
              value={editFormData?.vendoremail || ""}
              variant="outlined"
              sx={{backgroundColor:"white", width:"250px", height:"40px"}}
          />
       </TableCell>

       <TableCell  align="left">
        <TextField
              id="outlined-basic"
              size='small'
              name='vendoraddress'
              onChange={(event, newValue) => onChangeEditVendor(event, newValue)}
              label="Enter New Model Number"
              value={editFormData?.vendoraddress || ""}
              variant="outlined"
              sx={{backgroundColor:"white", width:"250px", height:"40px"}}
          />
       </TableCell>

       <TableCell align="left">
         <ButtonWrapper>
           <SubmitButton style={{marginRight:'10px'}} type="submit">Save</SubmitButton>
           <SubmitButton style={{marginRight:'10px'}} type="button" onClick={(e)=>handleCancelClick(e,k)}
           >Cancel</SubmitButton>
         </ButtonWrapper>                         
   </TableCell>
 </TableRow>     
       </>         
   )
}

export default VendorMasterEditable